import React from 'react';
import styled from 'styled-components';

const LdsRing = styled.div<{ color?: string }>`
  & {
    display: flex;
    position: relative;
    width: 16px;
    height: 16px;
    margin: 0px auto auto auto;
  }

  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 16px;
    height: 16px;
    border: 1px solid ${props => props.color || '#ffbb14'};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${props => props.color || '#ffbb14'} transparent transparent transparent;
  }
  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const SmallLoaderRing = (props: { loadingColor?: string }) => {
  return (
    <LdsRing className="lds-ring" color={props.loadingColor}>
      <div />
      <div />
      <div />
      <div />
    </LdsRing>
  );
};

export { SmallLoaderRing };
